import React, { useEffect } from "react";
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
  Flex,
  Box,
  VStack,
  Text,
  StackDivider,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { Link, NavLink, useLocation } from "react-router-dom";

const BurgerMenu = ({}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation();

  useEffect(() => {
    onClose();
  }, [location.pathname]);

  const btnRef = React.useRef();

  return (
    <>
      <Button ref={btnRef} colorScheme="teal" onClick={onOpen}>
        menu
      </Button>
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay>
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>
              <Link to="/">
                <Box>
                  <Text fontSize="3xl" fontWeight="bold" color="teal.500">
                    POTRAN
                  </Text>
                </Box>
              </Link>
            </DrawerHeader>

            <DrawerBody>
              <Flex flexDirection="column" p="0">
                <VStack
                  margin="30px 0"
                  divider={<StackDivider borderColor="gray.200" />}
                  spacing={4}
                  align="stretch"
                >
                  <NavLink
                    exact
                    activeStyle={{
                      fontWeight: "bold",
                      color: "teal",
                    }}
                    to="/projects"
                  >
                    <Flex
                      alignItems="center"
                      _hover={{
                        bg: "#eee",
                        paddingLeft: "10px",
                      }}
                      transition="0.2s"
                      p="5px 0"
                    >
                      PROJECTS
                    </Flex>
                  </NavLink>
                  <NavLink
                    exact
                    activeStyle={{
                      fontWeight: "bold",
                      color: "teal",
                    }}
                    to="/formation"
                  >
                    <Flex
                      alignItems="center"
                      _hover={{
                        bg: "#eee",
                        paddingLeft: "10px",
                      }}
                      transition="0.2s"
                      p="5px 0"
                    >
                      FORMATION
                    </Flex>
                  </NavLink>
                  <NavLink
                    exact
                    activeStyle={{
                      fontWeight: "bold",
                      color: "teal",
                    }}
                    to="/about"
                  >
                    <Flex
                      alignItems="center"
                      _hover={{
                        bg: "#eee",
                        paddingLeft: "10px",
                      }}
                      transition="0.2s"
                      p="5px 0"
                    >
                      MISC.
                    </Flex>
                  </NavLink>
                </VStack>
                <Box>
                  <Text fontSize="xl" fontWeight="bold">
                    CONTACT
                  </Text>
                  <Text m="10px 0">pierreoliviertran@gmail.com</Text>
                  <Text m="10px 0">06.79.63.36.78</Text>
                  <a target="_blank" href="https://potran.medium.com/">
                    <Text m="10px 0" fontWeight="bold" color="teal.500">
                      medium
                    </Text>
                  </a>
                  <a target="_blank" href="https://www.linkedin.com/in/potran/">
                    <Text m="10px 0" fontWeight="bold" color="teal.500">
                      linkedin
                    </Text>
                  </a>
                </Box>
              </Flex>
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </>
  );
};

export default BurgerMenu;
